<template>
    <div class="flex-box nopadding">
        <div style="width: 85px">
            <el-select size="small" :value="datearea_id" @change="onDteareaChange">
                <el-option :label="item.text" :value="index" v-for="(item,index) in datearea" :key="index"></el-option>
            </el-select>
        </div>
        <el-date-picker size="small" class="date-box" range-separator="-" value-format="yyyy-MM-dd"
                :value="select_date" type="daterange" :editable="false" :clearable="clearable"
                @input="onDateChange">
        </el-date-picker>
    </div>
</template>

<script>
    export default {
        name: "myDatePicker",
        model:{ //通过v-model传过来的参数
            prop: 'datearea_id',
            event: 'emitDateareaId'
        },
        props:{
            date_desc: {
                default: "",
                type: String
            },
            datearea_id:{
                default: 0,
                type: Number
            },
            clearable:{
                default: true,
                type: Boolean
            }
        },
        data:function(){
            return{
                select_date:[],
                datearea: this.$base.getDateArea()
            }
        },
        mounted: function(){
            if(this.datearea_id > 0){
                var item = this.datearea[this.datearea_id];
                this.select_date = [item.date_fr, item.date_to];
            }
        },
        methods: {
            onDteareaChange:function(index){
                this.$emit('emitDateareaId', index);
                if(index > 0) {
                    var item = this.datearea[index];
                    this.select_date = [item.date_fr, item.date_to];
                    this.$emit('onChange', this.select_date);
                }
            },
            onDateChange:function (value) {
                if(value){
                    this.select_date = [value[0], value[1]];
                }
                else{
                    this.select_date = ['', ''];
                }
                this.$emit('emitDateareaId', 0);
                this.$emit('onChange', this.select_date);
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myDatePicker.vue